import { locale, t } from '@/lib/i18n';
/** «hace 3 min», «hace 2 h», «hace 5 d». */
export function formatRelative(timestamp: number): string {
  const seconds = Math.floor((Date.now() - timestamp) / 1000);
  if (seconds < 60) return t('hace un momento');
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return t('hace {n} min', { n: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t('hace {n} h', { n: hours });
  const days = Math.floor(hours / 24);
  if (days < 30) return t('hace {n} d', { n: days });
  return new Date(timestamp).toLocaleDateString(locale());
}
